// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-post-js": () => import("/zeit/7f6a684/src/templates/post.js" /* webpackChunkName: "component---src-templates-post-js" */),
  "component---src-pages-index-js": () => import("/zeit/7f6a684/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

